var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.page_store.page.template == 'CAMPAIGN')?_c('CampaignTemplate'):_c('PageTemplate')}
var staticRenderFns = []

export { render, staticRenderFns }